import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Col, Form, Row, Button } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  ButtonCommon,
  DataTableProducts,
  SuggestionWidget,
  InputSearch,
  NotFoundTable,
  DropdownButton,
  BadgeFitprenda,
  ModalCommon,
} from "../../../common";
import "./List-ProdcutsNotFound.css";
import { FormattedMessage } from "react-intl";

const ListProductsNotFound = (props: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [products, setProducts] = useState([{}]);
  const [productSelection, setProductsSelection] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [genderSelect, setGenderSelect] = useState(0);
  const [uniqueSelect, setUniqueSelect] = useState(false);
  const [clothesType, setClothesType] = useState(0);
  const [clothesTypeSelect, setClothesTypeSelect] = useState(0);
  const [hiddenTitle, setHiddenaTitle] = useState(false);
  const [hiddenActions, setHiddenaActions] = useState(false);
  const [modalStep, setModalStep] = useState(1);

  const navigate = useNavigate();
  const params = useParams();

  console.log("LIST NOT FOUND PARAMS", params);

  async function getProductos() {
    try {
      setIsLoading(true);

      // const getProductResponse = await ProductServices.GetProducts();

      // if ((getProductResponse) && (getProductResponse.Status === 200)) {
      //     setProducts(getProductResponse.Content);
      // } else {
      //     setProducts([]);
      // }

      //setProducts([
      //  {
      //    Code: (
      //      <p>
      //        AAA11254 <BadgeFitprenda value={60} variant={"success"} />
      //      </p>
      //    ),
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //  {
      //    Code: "AAA11255",
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //  {
      //    Code: "AAA11256",
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //  {
      //    Code: "AAA11257",
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //  {
      //    Code: "AAA11258",
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //  {
      //    Code: "AAA11259",
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //  {
      //    Code: "AAA11260",
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //  {
      //    Code: "AAA11261",
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //  {
      //    Code: "AAA11262",
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //  {
      //    Code: "AAA11263",
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //  {
      //    Code: "AAA11264",
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //  {
      //    Code: "AAA11265",
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //  {
      //    Code: "AAA11266",
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //  {
      //    Code: "AAA11267",
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //  {
      //    Code: "AAA11268",
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //  {
      //    Code: "AAA11269",
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //  {
      //    Code: "AAA11270",
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //  {
      //    Code: "AAA11257",
      //    Alias: <DropdownButton />,
      //    Description: "",
      //    Position: "",
      //    Genre: "",
      //    Fit: "",
      //    Sizes: "",
      //    Category: "",
      //    SizeGuide: "",
      //  },
      //]);

      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  }

  // const refreshCountProducts = () => {
  //     if (props.onListProductChange) props.onListProductChange(products.length);
  // }

  useEffect(() => {
    getProductos();

    if (props.onListProductChange) props.onListProductChange(products.length);
  }, [products.length]);

  const onSuscribeProductsSelectionChange = (value: any) => {
    setProductsSelection(value);
  };

  const onClickGoBack = () => {
    navigate(-1);
  };

  const ModalContent = () => {
    return (
      <Form className="not-found-items-modal-container">
        {/* : mostrar estado 2 (modal parte 2) */}
        {modalStep === 1 ? (
          <>
            <div className="not-found-items-modal-sub-container">
              <p className="not-found-items-modal-upper-text">
                <FormattedMessage id="list-productnofound-modal-header" />
              </p>
              <p className="not-found-items-modal-item-title">
                <FormattedMessage id="list-productnofound-modal-head-item-title" />
              </p>
              <div>
                <p className="not-found-items-props">
                  <span className="not-found-items-props-bold">
                    <FormattedMessage id="ready-size-clothing-type" />
                  </span>{" "}
                  <FormattedMessage id="ready-size-superior" />
                </p>
                <p className="not-found-items-props">
                  <span className="not-found-items-props-bold">
                    <FormattedMessage id="ready-size-gender" />
                  </span>
                  <FormattedMessage id="ready-size-female" />
                </p>
                <p className="not-found-items-props">
                  <span className="not-found-items-props-bold">
                    <FormattedMessage id="ready-size-fit" />
                  </span>
                  <FormattedMessage id="list-productnofound-modal-fit-option" />
                </p>
                <p className="not-found-items-props">
                  <span className="not-found-items-props-bold">
                    <FormattedMessage id="list-productnofound-modal-sizes" />
                  </span>{" "}
                  <FormattedMessage id="list-productnofound-modal-sizes-options" />
                </p>
              </div>
            </div>
          </>
        ) : (
          <div className="associate-succes-modal">
            <img
              className="product-not-found-associate-succes-modal-image"
              src="/img/assosciate-succes.png"
              alt="Succes"
              width={250}
            />
            <p className="associate-succes-modal-p">
              <FormattedMessage id="list-productnofound-recognized-products" />
            </p>
          </div>
        )}
      </Form>
    );
  };

  const onHideModal = () => {
    setShowModal(false);
  };

  const onOkModal = () => {
    setHiddenaTitle(true);
    setHiddenaActions(true);
    setModalStep(2);
  };

  const onInitSizeGuideTemplate = (idType: number) => {
    setClothesType(idType);
    setClothesTypeSelect(idType);
    setGenderSelect(2);
    setUniqueSelect(false);
    setShowModal(true);
  };

  const onShowModal = () => {
    setModalStep(1);
    setShowModal(true);
    setHiddenaTitle(false);
    setHiddenaActions(false);
  };

  const contentInternalMainBox = () => {
    return (
      <button
        className="notfound-items-modal"
        onClick={() => onInitSizeGuideTemplate(1)}
      >
        Asociar Sugerencia
      </button>
    );
  };

  return (
    <>
      <div className="notfound-products-container">
        <div className="notfound-products-help-widgets">
          <Row>
            <Col className="notfound-products-help-widget">
              <SuggestionWidget
                description={
                  <FormattedMessage id="list-productnofound-suggestionwidget-left-desc" />
                }
                title={
                  <FormattedMessage
                    id="ready-size-help"
                    defaultMessage="Ayuda"
                  />
                }
              />
            </Col>
            <Col className="notfound-products-help-widget">
              <SuggestionWidget
                description={
                  <FormattedMessage id="list-productnofound-suggestionwidget-right-desc" />
                }
                title={
                  <FormattedMessage id="list-productnofound-suggestionwidget-right-title" />
                }

                // title="Otra forma de resolverlo"
                // description="Desde tu página de ecommerce,  debes ocultar el botón de ReadySize en los productos No reconocidos.

                // Te explicamos cómo hacerlo en la documentación (link)."
              />
            </Col>
          </Row>
        </div>

        <div className="notfound-products-search-buttons">
          <div className="notfound-products-search">
            <InputSearch className="input-search-container" />
          </div>
          <div className="notfound-products-buttons">
            <div className="notfound-products-buttons-borrar">
              <ButtonCommon
                className="notfound-products-buttons-inner"
                label={
                  <FormattedMessage
                    id="delete-tooltip"
                    defaultMessage="Borrar"
                  />
                }
              />
            </div>

            <div className="notfound-products-asociar">
              <button
                className="notfound-products-buttons-asociar"
                onClick={onShowModal}
              >
                <FormattedMessage
                  id="product-registration-modal-title"
                  defaultMessage="Borrar"
                />
              </button>
            </div>
          </div>
        </div>

        <div>
          <NotFoundTable
            products={products}
            isLoading={isLoading}
            scrollHeight={"flex"}
            handlerSelectionRow={onSuscribeProductsSelectionChange}
          />
          {/* Size Guides */}
          {/* Modal Template */}
          <ModalCommon
            Title="product-registration-modal-title"
            buttonSuccessTitle="products-form-modal-successbutton"
            Show={showModal}
            OnModalClose={onHideModal}
            OnModalOk={onOkModal}
            Content={ModalContent()}
            HiddenTitle={hiddenTitle}
            HiddenActions={hiddenActions}
          />
        </div>

        {/* <Row className="justify-content-center">
          <DataTableProducts
            products={products}
            isLoading={isLoading}
            scrollHeight={"flex"}
            handlerSelectionRow={onSuscribeProductsSelectionChange}
            // handlerDelete={onSuscribeDelete}
            // handlerEdit={onSuscribeEdit}
            // handlerAddSizeGuide={onSuscribeAddSizeGuide}
          />
        </Row> */}

        {/* <Row className="mt-3">
          <Col xs={2} className="ps-0">
            <ButtonCommon
              label="Ir a productos"
              isOutline={true}
              eventClick={() => onClickGoBack()}
            />
          </Col> */}
        {/* <Col xs={1} className={((productSelection.length === 0) ? 'd-none' : 'd-block') + ' ps-0'}>
                    <ButtonCommon label="Guardar"
                        isOutline={false} 
                        disabled={((productSelection.length === 0) ? true : false)}
                        eventClick={onClickGoBack} />
                </Col> */}
        {/* </Row> */}
      </div>
    </>
  );
};

export default ListProductsNotFound;
